module.exports = __webpack_public_path__ + "img/peacejam-logo.cd08953d.png";